<template>
  <nav class="nav" id="nav">
    <div class="container container--nav">
      <div class="nav__bar">
        <router-link class="nav__logo" to="/">
          <img
            class="nav__image"
            :src="require(`@/assets/logos/cube_1.svg`)"
            alt="Jorify logo"
          />
        </router-link>
        <router-link class="nav__logo" to="/">
          <img
            class="nav__image"
            :src="require(`@/assets/logos/jorify.svg`)"
            alt="Jorify logo"
          />
        </router-link>
        <div class="nav__hamburger" @click="toggleDropdown">
          <span v-if="!isDropdownOpen"
            ><img
              class=""
              :src="require(`@/assets/icons/menu.svg`)"
              alt="Jorify logo"
          /></span>
          <span v-else
            ><img
              class=""
              :src="require(`@/assets/icons/close.svg`)"
              alt="Jorify logo"
          /></span>
        </div>
        <ul class="nav__links" :class="{ 'nav__links--open': isDropdownOpen }">
          <li class="nav__link" @click="closeDropdown">
            <router-link to="/"> Home</router-link>
          </li>
          <li class="nav__link" @click="closeDropdown">
            <router-link to="/about"> About</router-link>
          </li>
          <!--          <li class="nav__link" @click="closeDropdown">-->
          <!--            <router-link to="/projects"> Projects</router-link>-->
          <!--          </li>-->
          <li class="nav__link" @click="closeDropdown">
            <router-link to="/contact"> Contact</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      isDropdownOpen: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
    closeDropdownOnResize() {
      if (window.innerWidth > 768) {
        this.isDropdownOpen = false;
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.closeDropdownOnResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.closeDropdownOnResize);
  },
};
</script>

<style scoped>
.nav {
  position: sticky;
  top: 0;
  background-color: black;
  z-index: 2;
}

.nav__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  height: calc(88px - 16px);
}

.nav__logo {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  margin-right: 16px;
}

.nav__image {
  height: 100%;
  width: auto;
}

.nav__hamburger {
  cursor: pointer;
  display: none;
}

.nav__links {
  display: flex;
}

@media only screen and (min-width: 768px) {
  .nav__links {
    flex-grow: 1;
    justify-content: flex-end;
  }
}

.nav__links--open {
  display: block;
}

.nav__link {
  padding-left: 24px;
  list-style: none;
  font-size: 20px;
}

.nav__link a {
  color: var(--color-heading);
  text-decoration: none;
  font-weight: bold;
}

.nav__link a.active-class {
  color: white;
}

.nav__link:hover {
  text-decoration: underline;
}

@media only screen and (max-width: 768px) {
  .nav__links {
    display: none;
    position: absolute;
    flex-direction: column;
    background-color: black;
    width: 100%;
    text-align: center;
    padding: 20px 0;
    top: calc(88px - 16px);
    left: 0;
  }

  .nav__links--open {
    display: flex;
  }

  .nav__hamburger {
    display: block;
  }
}
</style>
